export enum ToastTypeEnum {
  Success = 'success',
  Error = 'error',
  Warn = 'warn',
}

export interface ShowToastProps {
  message: string;
  type: ToastTypeEnum;
}

export const Solution_Toast: Record<string, ShowToastProps> = {
  FEASIBILITY_NOT_FOUND: {
    message: 'Feasibility not found',
    type: ToastTypeEnum.Warn,
  },
  BENEFITS_NOT_FOUND: {
    message: 'Benefits not found',
    type: ToastTypeEnum.Warn,
  },
};
